<div class="zn-step-content-sections">
  <div [class]="propertyTypeSectionClass()">
    <div class="zn-step-content-section-header">
      <h5>{{ (localizationKeyPrefix + '.PropertyType.Title') | abpLocalization }}</h5>
      <p>{{ (localizationKeyPrefix + '.PropertyType.Description') | abpLocalization }}</p>
      <hr class="zn-separator">
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-step-content-section-layout">
        <div class="zn-step-content-section-filters">
          <div class="form-control-container">
            <label class="form-label" for="propertyType">
              {{ 'Controlling::Entity.PropertyTypeRegionParameter.PropertyType' | abpLocalization }}
              <span class="form-label-required">*</span>
            </label>
            <zn-single-select
              #propertyTypeSelect
              id="propertyType"
              [options]="propertyTypeOptions()"
              [optionsLoader]="loadPropertyTypes"
              [showSearch]="true"
              [localizationResource]="localizationResource"
              [openUp]="false"
              (selectedChange)="onPropertyTypeChange($event)"
            >
            </zn-single-select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [class]="tableSectionClass()">
    <div class="zn-step-content-section-header">
      <h5>{{ (localizationKeyPrefix + '.Table.Title') | abpLocalization }}</h5>
      <p>{{ (localizationKeyPrefix + '.Table.Description') | abpLocalization }}</p>
      <hr class="zn-separator">
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-table" [class.zn-table--empty]="rows().length === 0">
        <div class="zn-table-scroll">
          <table class="zn-table-element">
            <thead>
              <tr>
                <th>{{ columnHeaderKeys.stand | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.cycle | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.rotation | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.area | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.standType | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.nearbyPopulation | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.maintenancePeriod | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.maintenanceReason | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.adjustmentType | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.plantationDate | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.ownPlantation | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.spacing | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.geneticMaterial | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.species | abpLocalization }}</th>
              </tr>
            </thead>
            <tbody>
              @if (rows().length === 0) {
                <tr>
                  <td class="zn-table-empty" colspan="14">
                    {{ 'LanguageService::EmptySearchResultTitle' | abpLocalization }}
                  </td>
                </tr>
              }
              @for (row of rows(); track row.key) {
                <tr>
                  <td>{{ row.stand }}</td>
                  <td>{{ row.cycle }}</td>
                  <td>{{ row.rotation }}</td>
                  <td>{{ row.area }}</td>
                  <td>{{ row.standType }}</td>
                  <td>{{ row.nearbyPopulation }}</td>
                  <td>{{ row.maintenancePeriod }}</td>
                  <td>{{ row.maintenanceReason }}</td>
                  <td>{{ row.adjustmentType }}</td>
                  <td>{{ row.plantationDate }}</td>
                  <td>{{ row.ownPlantation }}</td>
                  <td>{{ row.spacing }}</td>
                  <td>{{ row.geneticMaterial }}</td>
                  <td>{{ row.species }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
